import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, escolherPlaca } from './types';

export const INITIAL_STATE: escolherPlaca = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): escolherPlaca {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ESCOLHER_PLACA_REQUEST: {
				break;
			}

			case Types.ESCOLHER_PLACA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ESCOLHER_PLACA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ESCOLHER_PLACA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONFIRMAR_PLACA_ESCOLHIDA: {
				draft.status = state.status;
				draft.data = state.data;
				draft.placaEscolhida = action.payload.placaEscolhida;
				break;
			}

			default:
		}
		return draft;
	});
}
